import * as React from "react";
import { Box, Modal, Container, IconButton } from "@mui/material/";
import { SecondaryButton } from "../Buttons";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";

export default function RelationPopup({
  handleClose,
  relationPopupText,
  open,
  handleConfirm,
  disable,
}) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: "15px",
    boxShadow: 24,
    p: 4,
    textAlign: "center",
    padding: "20px 20px",
  };

  const { t } = useTranslation();
 
  return (
    <Modal
      keepMounted
      open={open}
      // onClose={handleClose}
      aria-labelledby="keep-mounted-modal-title"
      aria-describedby="keep-mounted-modal-description"
    >
      <Container maxWidth="lg" >
        <Box sx={style}>
          <Box sx={{ width: "100% " }}>
            <IconButton
              onClick={handleConfirm}
              sx={{ marginLeft: "90%", padding: "0" }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <p style={{ padding: "45px 20px", fontWeight: "500" }}>
            {t(relationPopupText)}
          </p>

          <SecondaryButton
            width="110px"
            padding="4px 16px"
            borderRadius="11px"
            fullWidth={false}
            textTransform="capitalize"
            title={"OK"}
            click={handleConfirm}
            disabled={disable}
          />
        </Box>
      </Container>
    </Modal>
  );
}
